import { createAsyncActionTypes } from 'misc/utils';

const PREFIX = 'invoices';

export const CREATE = createAsyncActionTypes(`${PREFIX}/CREATE`);
export const LIST = createAsyncActionTypes(`${PREFIX}/LIST`);
export const UPDATE = createAsyncActionTypes(`${PREFIX}/UPDATE`);
export const PATCH = createAsyncActionTypes(`${PREFIX}/PATCH`);
export const PRINT = createAsyncActionTypes(`${PREFIX}/PRINT`);